import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { newsItems } from './newsContent/newsContent';
import VideoIframe from './contentUtils/videoIFrame';
import TrackEmbed from './contentUtils/trackEmbed';
import { useIsMobile } from '../../utils/useIsMobile';
import { primaryColor } from '../../assets/colors';

const useStyles = makeStyles()((theme) => ({
  newsItem: {
    marginBottom: '64px',
  },
  newsItemMobile: {
    marginBottom: '48px',
  },
  dateWrapper: {
    color: primaryColor,
  },
  iFrameYouTube: {
    border: 'none',
    width: '960px',
    height: '600px',
  },
  iFrameYouTubeMobile: {
    border: 'none',
    width: '100%',
    height: '225px',
  },
  iFrameSpotify: {
    border: 'none',
    width: '960px',
  },
  iFrameSpotifyMobile: {
    border: 'none',
    width: '100%',
  },
}));

const Item = styled(Paper)(() => ({
  textAlign: 'left',
  backgroundColor: 'black',
  color: 'inherit',
}));

const NewsComponent: React.FC = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        // MOBILE
        <>
          <div className='title title-mobile content-wrapper'>UUTISET</div>
          <div className='text-body text-body-mobile content-wrapper'>
            {newsItems.map((item) => {
              return (
                <div className={classes.newsItemMobile}>
                  <div className={classes.dateWrapper}>{item.date}</div>
                  <div>{item.subject}</div>
                  {item.youTubeVideoId && (
                    <VideoIframe
                      videoId={item.youTubeVideoId}
                      className={classes.iFrameYouTubeMobile}
                    />
                  )}
                  {item.spotifySongId && (
                    <TrackEmbed
                      trackUrlOrId={item.spotifySongId}
                      className={classes.iFrameSpotifyMobile}
                      height={80}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </>
      ) : (
        // DESKTOP
        <>
          <div className='title title-desktop content-wrapper'>UUTISET</div>
          <div className='text-body text-body-desktop content-wrapper'>
            {newsItems.map((item) => {
              return (
                <div className={classes.newsItem}>
                  <Grid container spacing={2}>
                    <Grid size={1} className={classes.dateWrapper}>
                      <Item>{item.date}</Item>
                    </Grid>
                    <Grid size={11}>
                      <Item>{item.subject}</Item>
                    </Grid>
                    {item.youTubeVideoId && (
                      <>
                        <Grid size={1}></Grid>
                        <Grid size={11}>
                          <Item>
                            <VideoIframe
                              videoId={item.youTubeVideoId}
                              className={classes.iFrameYouTube}
                            />
                          </Item>
                        </Grid>
                      </>
                    )}
                    {item.spotifySongId && (
                      <>
                        <Grid size={1}></Grid>
                        <Grid size={11}>
                          <Item>
                            <TrackEmbed
                              trackUrlOrId={item.spotifySongId}
                              className={classes.iFrameSpotify}
                              height={120}
                            />
                          </Item>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default NewsComponent;
